import { render, staticRenderFns } from "./Film.vue?vue&type=template&id=2086da6e&"
import script from "./Film.vue?vue&type=script&lang=js&"
export * from "./Film.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2086da6e', component.options)
    } else {
      api.reload('2086da6e', component.options)
    }
    module.hot.accept("./Film.vue?vue&type=template&id=2086da6e&", function () {
      api.rerender('2086da6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Routes/Film.vue"
export default component.exports